import { LightboxUiLockActions } from '../constants/lightbox_ui_lock/lightbox_ui_lock_actions';
import Dispatcher from '../dispatcher';

function showAction() {
    Dispatcher.handleLightboxUiLockAction({ type: LightboxUiLockActions.SHOW_ACTION });
}

function hideAction() {
    Dispatcher.handleLightboxUiLockAction({ type: LightboxUiLockActions.HIDE_ACTION });
}

function loadingDoneAction() {
    Dispatcher.handleLightboxUiLockAction({ type: LightboxUiLockActions.LOADING_DONE_ACTION });
}

export {
    showAction,
    hideAction,
    loadingDoneAction
};